import * as types from './mutation-types'
import ClientDB from '@/rahmen/clientDB'
import conf from '@/rahmen/conf'

export const loadDatas = ({ commit, state }, tbName) => {
  console.log('tempdate:loadDatas')
  return new Promise((resolve, reject) => {
    const db = new ClientDB(conf.tempDataStoreName)
    console.log('tempData:db open', conf.tempDataStoreName, tbName)
    db.get(tbName).then((data) => {
      console.log('tempData:get')
      console.log(data)
      if (data === undefined || data.value === undefined) {
        console.log('no data registed')
        reject(data)
        return
      }
      commit(types.SAVE_TEMP_DATA, { id: tbName, data: data.value })
      resolve()
    }).catch((e) => {
      console.log('tempdata:get error', e)
      reject(e)
    })
  })
}
export const saveDatas = ({ commit }, { tbName, tempData }) => {
  _saveDataToDB(tbName, tempData)
}

const _saveDataToDB = (tbName, tempData) => {
  console.log('tempData:save start', tempData)
  const db = new ClientDB(conf.tempDataStoreName)
  db.register(tbName, tempData)
    .catch(e => {
      console.error(e)
    })
}
